<template>
  <div class="home">
    <div>
      <PepperScene ref="scene" id="scene"/>
      <PepperTopic ref="scene" id="topic"/>
      <PepperNews ref="scene" id="news"/>
      <PepperTrend ref="scene" id="trend" data-csv="./data/trend-weekly.csv"/>
      <TheComments url="https://udn.com/newmedia/election2020/chuchupepper/"/>
    </div>
  </div>
</template>

<script>
import PepperScene from '@/components/PepperScene'
import PepperTopic from '@/components/PepperTopic'
import PepperNews from '@/components/PepperNews'
import PepperTrend from '@/components/PepperTrend'
import TheComments from '@/components/TheComments'

export default {
  name: 'home',
  components: {
    PepperScene,
    PepperTopic,
    PepperNews,
    PepperTrend,
    TheComments
  }
}
</script>

<style lang="scss">
.home {
  @include rwd($RWD_TABLET) {
    padding-right: 70px;
  }
}
</style>
